import React from 'react'
import { useSelector } from 'react-redux'

import MainEdit from '../MainContainer/components/MainEdit'
import MainView from '../MainContainer/components/MainView'

import styles from './styles.module.scss'

export default function MainContainer() {
  const { profileData } = useSelector((state) => state.myProfile)

  return <div className={`${styles.mainContainer}`}>{profileData.editable === 1 ? <MainEdit /> : <MainView />}</div>
}
